import { NgModule } from '@angular/core';
import { AuthSignal } from './auth.signal';
import { CommonSignal } from './common.signal';
import { NoticeSignal } from './notice.signal';
import { TreeSignal } from './tree.signal';
import { BatchSignal } from './batch.signal';
import { PreviewSignal } from './preview.signal';
import { TabSignal } from './tab.signal';

@NgModule({
    declarations: [
    ],
    providers: [
        AuthSignal,
        CommonSignal,
        NoticeSignal,
        TreeSignal,
        BatchSignal,
        PreviewSignal,
        TabSignal
    ]
})
export class SignalModule { }
export * from './auth.signal';
export * from './common.signal';
export * from './notice.signal';
export * from './tree.signal';
export * from './batch.signal';
export * from './preview.signal';
export * from './tab.signal';
export * from './tab-signal-set';
export * from './tab-signal-action';
